import type { ReactElement } from 'react';
import React from 'react';
import clsx from 'clsx';
import { format } from 'date-fns';
import PeriodBadge from 'feature-components/badges/period-badge/period-badge';
import { commonDateFormat } from 'helpers/date.helpers';
import { useIsSchool } from 'services/providers/auth.hooks';
import './index.scss';

type Props = {
  period: { startDate: string; endDate: string };
  theme?: string;
  className?: string;
};

export default function ReportFooter(props: Props): ReactElement {
  const isSchool = useIsSchool();
  const {
    period: { startDate, endDate },
    theme,
    className
  } = props;
  return (
    <div className={clsx('report-footer', className, theme)}>
      <div className="report-branding">
        &copy; NZCER
        <img src="/assets/nzcer-logo.jpg" alt="nzcer-logo" />
      </div>
      <div className="report-date">
        {isSchool && <PeriodBadge startDate={startDate} endDate={endDate} showInputDates />}
        {!isSchool && (
          <span className="formatted-date">
            {format(new Date(startDate), commonDateFormat)} -{' '}
            {format(new Date(endDate), commonDateFormat)}
          </span>
        )}
      </div>
    </div>
  );
}
